module.exports = require('../../../app_adyen_SFRA/cartridge/config/constants');
